import { useContext } from 'react';
import { CurrencyFormatterContext } from './CurrencyFormatterProvider';
export var useCurrencyFormatter = function (overrides) {
    var createCurrencyFormatter = useContext(CurrencyFormatterContext);
    if (!createCurrencyFormatter) {
        throw new Error('`useCurrencyFormatter` was called with illegal value provided to CurrencyFormatterProvider');
    }
    return createCurrencyFormatter(overrides);
};
//# sourceMappingURL=useCurrencyFormatter.js.map